import React, {Component} from 'react'
import {
    Form,
    Input,
    Upload,
    Select,
    Button,
    Icon,
    Col,
    Popconfirm,
    message
} from 'antd';
import {baseUrl,reqAddCompany} from '../../api'
import ajax from "../../api/ajax";
import './company-add.less'
class CompanyAdd extends Component {

    state = {
        fileList:[],
        picturePath:''
    }

    componentWillMount() {
    }

    handleSave = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                message.error(err)
            } else {
                this.saveFileData(values)
            }
        });
    }

    saveFileData = async (data) => {
        let result = await reqAddCompany(data)
        if (result.code === 200) {
            message.success(result.message)
            this.props.history.replace('/companyList')
        } else {
            message.error(result.message)
        }
    }

    handleRemove= info =>{
        let result = ajax(baseUrl+'/api/v1/p/file/fileDel',{"fileId":info.id},'DELETE');
        result.then(function(value) {
            if(value.code===200) {
                return true;
            }else{
                message.error(value.message)
            }
        }, function(error) {
            message.error(error)
        });
        this.setState({
            picturePath:''
        })
    };

    handleChange = info => {
        let fileList = [...info.fileList];
        if(info.file.size > 1048576){
            message.error('图片大小应小于1MB');
            return false
        }else{
            fileList = fileList.map(file => {
                if (file.response) {
                    if (file.response.code === 200) {
                        file.url = baseUrl + '/' + file.response.data.filePath;
                        this.setState({
                            picturePath:file.url
                        })
                        file.id = file.response.data.id;
                    } else {
                        file.status = 'error';
                        file.response = file.response.message;
                    }
                }
                return file;
            });
    
            this.setState({fileList});
        }
        
    };

    render() {
        const form = this.props.form
        const {getFieldDecorator} = form;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                md: {span: 4},
            },
            wrapperCol: {
                xs: {span: 24},
                md: {span: 16},
            },
        }

        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">点击上传</div>
            </div>
        );

        const props = {
            name: 'file',
            listType:"picture-card",
            action: baseUrl + '/api/v1/p/file/upLoad?objectType=businessLicense',
            onChange:this.handleChange,
            onRemove:this.handleRemove,
            withCredentials: true,
        };
        const {fileList} = this.state
        return (
            <div className='box-shadow padding-20'>
                <div className='head-title'>企业信息新增</div>
                <br/>
                <div>
                    <Form {...formItemLayout}>
                        <Form.Item label="企业名称:">
                            {getFieldDecorator('companyName', {
                                rules: [{required: true, message: '该项必填'}]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="企业税号:">
                            {getFieldDecorator('companyTaxNo', {
                                rules: [{required: true, message: '该项必填'}]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="企业统一信用证代码:">
                            {getFieldDecorator('creditIdentification', {
                                rules: [{required: true, message: '该项必填'}]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="注册地:">
                            {getFieldDecorator('registerLocal', {
                                rules: [{required: true, message: '该项必填'}]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="法人姓名:">
                            {getFieldDecorator('legalPerson', {
                                rules: [{required: true, message: '该项必填'}]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="法人电话:">
                            {getFieldDecorator('legalPersonPhone', {
                                rules: [{required: true, message: '该项必填'}]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="法人邮箱:">
                            {getFieldDecorator('legalPersonEmail', {
                                rules: [{required: true, message: '该项必填'}]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="企业营业执照:">
                        <Upload  {...props}  fileList={fileList}>
                                {fileList.length >= 1? null : uploadButton}
                            </Upload>
                            {getFieldDecorator('businessLicense', {
                                rules: [{required: true, message: '该项必填'}],
                                initialValue:this.state.picturePath
                            })}
                         </Form.Item>
                       
                        <Form.Item className='newFileOpt'>
                            <Popconfirm title="是否确定保存?" onConfirm={this.handleSave}>
                                <Button type='primary'>保存</Button>
                            </Popconfirm>
                        </Form.Item>
                    </Form>
                </div>
            </div>

        )
    }
}
const CompanyFrom = Form.create()(CompanyAdd)
export default CompanyFrom